const initialState = {
  tableDetails: null,
  extendLoading: false,
  endLoading: false,
  orderType: null,
  allTablesData: {},
};

export default function tableReducer(
  state = initialState,
  { type, payload, action }
) {
  switch (type) {
    case "FETCH_ALL_TABLES_SUCCESS":
      return {
        ...state,
        allTablesData: payload,
      };
    case "TABLE_UPDATE": {
      return {
        ...state,
        tableDetails: payload,
      };
    }
    case "EXTEND_LOADING":
      return {
        ...state,
        extendLoading: {
          ...state.extendLoading,
          [payload.tableId]: payload.loading,
        },
      };
    case "END_LOADING":
      return {
        ...state,
        endLoading: {
          ...state.endLoading,
          [payload.tableId]: payload.loading,
        },
      };

    default:
      return state;
  }
}
